import { Table } from '@thinknet-gmbh/platform-common-ui';
import styled from 'styled-components';

export const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    padding: 9px 12px;
  }
  .ant-table-content .ant-table-tbody .ant-table-row td > div {
    padding: 5px 12px;
  }
  .ant-table-tbody > tr {
    &:last-child > td {
      border-bottom: none;
    }
    td:last-child > div {
      display: block !important;
    }
  }
`;
